import React from 'react';

import './compiled/Footer.css';

const footer = props => {
  let this_year = new Date().getFullYear();
  let footer_links = [
    {
      href:
        'https://chrome.google.com/webstore/detail/full-page-screen-capture/fdpohaocaechififmbbbbbknoalclacl?hl=en-US',
      text: 'Extension in chrome store'
    },
    {
      href: 'https://mrcoles.com/full-page-screen-capture-chrome-extension/',
      text: 'Original blog post'
    },
    {
      href: 'https://mrcoles.com/full-page-screen-capture/privacy/',
      text: 'Privacy'
    }
  ];

  return (
    <footer>
      <div className="container clr">
        <p className="left">
          {footer_links.map((x, i) => (
            <span key={i}>
              <a href={x.href}>{x.text}</a>
            </span>
          ))}
        </p>
        <p className="right text-right">
          Made with ♥ in NYC<br />
          &copy; {this_year}
        </p>
      </div>
    </footer>
  );
};

export default footer;
